import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
/* eslint-disable react-hooks/exhaustive-deps */
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";

import { useCoupons } from "../apis";
import { CouponType } from "../constants";

const useCustomCouponsList = (type: CouponType) => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = {
    page,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT,
    search: debouncedSearch,
    type
  };

  const {
    coupons,
    meta,
    isLoading,
    refetch: refetchCoupons
  } = useCoupons(requestParams);

  return {
    coupons,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchCoupons
  };
};

export default useCustomCouponsList;
